import { SkeletonText } from '@pixum/skeleton';
import styles from './DeliveryDateStream.module.css';

export function DeliveryDateSkeleton() {
  return <SkeletonText aria-busy aria-label="Loading delivery date" className={styles.deliveryDateSkeleton} lines={1} />;
}
